import type { IOffice } from '@alfa-bank/site-dc-form-api/src/models';

import type { TOfficesSortedByPid, TSortedOfficesToSelector, TSortedConstraints } from './models';

const NON_WORKING_DAY_LABEL = 'выходной';

export const sortOfficesByPid = (data: IOffice[]): TOfficesSortedByPid =>
    data.reduce((acc: TOfficesSortedByPid, office: IOffice) => {
        const { address, constraints, metro, pid, schedule, title } = office;
        // TODO: перепроверить формат данных в ответе
        /** Получаем данные вида:
        "schedule": [
            "пн-чт: 09:00-20:00",
            "пт: 15:00-19:00",
            "сб-вс: выходной"
        ], в массиве не больше 7 строк (по дням недели). Преобразовываем в вид:
        workingHours = [
            {day: 'пн-чт', time: '09:00-20:00'},
            {day: 'пт', time: '15:00-19:00'},
            {day: 'сб-вс', time: 'выходной'},
        ]
         */

        const workingHours = schedule.map(fullString => {
            // Разделяем строку по первому двоеточию на день и время
            const firstColon = fullString.indexOf(':');
            const day = fullString.substring(0, firstColon).trim();
            const time = fullString.substring(firstColon + 1).trim();

            return { day, time };
        });

        // TODO: перепроверить формат данных в ответе
        const sortedConstraints = constraints.reduce((prev: TSortedConstraints[], curr) => {
            // Регулярка на наличие в строке времени формата HH:MM
            const regExpTime = /\b(?:[01]\d|2[0-3]):[0-5]\d\b/;

            if (curr.time) {
                prev.push({ date: curr.date, time: curr.time });
            } else {
                // Проверяем кейс, когда в date приходит строка с датой и временем,
                // например: '1 сентября c 10:00 до 19:00'. Если нет, значит
                // в date только дата и это выходной
                if (curr.date.match(regExpTime)) {
                    prev.push({ date: curr.date, time: '' });
                } else {
                    prev.push({ date: curr.date, time: NON_WORKING_DAY_LABEL });
                }
            }

            return prev;
        }, []);

        const newObj = {
            address,
            metro,
            schedule: workingHours,
            title,
            constraints: sortedConstraints,
        };

        if (acc[pid]) {
            acc[pid] = { ...acc[pid], ...newObj };
        } else {
            acc[pid] = { ...newObj };
        }

        return acc;
    }, {});

export const prepareDataToSelector = (data: IOffice[]) => {
    const sortedByCity = data.reduce((acc: TSortedOfficesToSelector, office) => {
        const { address, city, pid } = office;
        const { name } = city;

        if (acc[name]) {
            acc[name].options.push({ key: pid, content: address, category: name });
        } else {
            acc[name] = { label: name, options: [{ key: pid, content: address, category: name }] };
        }

        return acc;
    }, {});

    return Object.values(sortedByCity);
};
